import { SIDEBAR_LS_KEY } from 'conversations/modules/sidebar/constants'
import { captureError } from 'conversations/utils/logRocket'
import produce from 'immer'
import { combineReducers } from 'redux'
import { fetchMessagesAsync } from 'shared/store/actions/message'
import {
  hideConversationLogsSidebar,
  hideDetailsSidebar,
  hideKeyboardShortcutsSidebar,
  hideRoutingAuditLogSidebar,
  hideRoutingLogsSidebar,
  showConversationLogsSidebar,
  showDetailsSidebar,
  showKeyboardShortcutsSidebar,
  showRoutingAuditLogSidebar,
  showRoutingLogsSidebar,
  toggleDetailsSidebar,
} from 'shared/store/actions/sidebar'
import { localStore } from 'shared/utils/storage'

import { createReducer } from 'typesafe-actions'

import { overlay } from './overlay/reducer'

const initialState = {
  keyboardShortcutsSidebarVisible: false,
  detailsSidebarVisible: true,
  conversationLogsSidebarVisible: false,
  routingLogsSidebarVisible: false,
  routingAuditLogSidebarVisible: false,
}

const getInitialState = () => {
  const storedSidebar = localStore.get(SIDEBAR_LS_KEY)
  if (storedSidebar) {
    try {
      return JSON.parse(storedSidebar)
    } catch (err) {
      captureError(err, 'Sidebar parse failed')
    }
  }
  return initialState
}

const sidebar = createReducer<Record<string, boolean>>(getInitialState())
  // KEYBOARD SHORTCUTS
  .handleAction(showKeyboardShortcutsSidebar, (state) =>
    produce(state, (draft) => {
      draft.keyboardShortcutsSidebarVisible = true
      draft.detailsSidebarVisible = false
      draft.conversationLogsSidebarVisible = false
      draft.routingLogsSidebarVisible = false
      draft.routingAuditLogSidebarVisible = false
    })
  )
  .handleAction(hideKeyboardShortcutsSidebar, (state) =>
    produce(state, (draft) => {
      draft.keyboardShortcutsSidebarVisible = false
    })
  )
  // CONVERSATION LOGS
  .handleAction(showConversationLogsSidebar, (state) =>
    produce(state, (draft) => {
      draft.conversationLogsSidebarVisible = true
    })
  )
  .handleAction(hideConversationLogsSidebar, (state) =>
    produce(state, (draft) => {
      draft.conversationLogsSidebarVisible = false
    })
  )
  // DETAILS
  .handleAction(showDetailsSidebar, (state) =>
    produce(state, (draft) => {
      draft.detailsSidebarVisible = true
      draft.keyboardShortcutsSidebarVisible = false
    })
  )
  .handleAction(hideDetailsSidebar, (state) =>
    produce(state, (draft) => {
      draft.detailsSidebarVisible = false
    })
  )
  .handleAction(toggleDetailsSidebar, (state) =>
    produce(state, (draft) => {
      draft.detailsSidebarVisible = !state.detailsSidebarVisible
      draft.keyboardShortcutsSidebarVisible = false
    })
  )
  // ROUTING LOGS
  .handleAction(showRoutingLogsSidebar, (state) =>
    produce(state, (draft) => {
      draft.routingLogsSidebarVisible = true
      draft.keyboardShortcutsSidebarVisible = false
    })
  )
  .handleAction(hideRoutingLogsSidebar, (state) =>
    produce(state, (draft) => {
      draft.routingLogsSidebarVisible = false
      draft.detailsSidebarVisible = true
    })
  )
  // ROUTING AUDIT LOG
  .handleAction(showRoutingAuditLogSidebar, (state) =>
    produce(state, (draft) => {
      draft.routingAuditLogSidebarVisible = true
      draft.conversationLogsSidebarVisible = false
      draft.keyboardShortcutsSidebarVisible = false
    })
  )
  .handleAction(hideRoutingAuditLogSidebar, (state) =>
    produce(state, (draft) => {
      draft.routingAuditLogSidebarVisible = false
      draft.detailsSidebarVisible = true
    })
  )
  // HIDE SIDEBAR IF CONVERSATION FETCHING FAILS
  .handleAction(fetchMessagesAsync.failure, (state) =>
    produce(state, (draft) => {
      draft.keyboardShortcutsSidebarVisible = false
      draft.detailsSidebarVisible = false
      draft.conversationLogsSidebarVisible = false
      draft.routingLogsSidebarVisible = false
      draft.routingAuditLogSidebarVisible = false
    })
  )

export default combineReducers({
  sidebar,
  overlay,
})
